import { IAdvertisedCoursesRes } from "../../models/advertisedcourse.model";
import {
  ICreateAnnouncement,
  IAvailableCoureResponse,
  IAvailableCourse,
} from "../../models/trainee-course.model";
import deleteService from "../deleteService";
import getService from "../getService";
import postService from "../postService";
import putService from "../putService";

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/";

class ProgramModuleService {
  async getModules() {
    const response = await getService.get(
      `${CONFIG_API_URL}program-data/modules`
    );
    return response.data;
  }
  async getModuleById(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}program-data/modules/${uuid}`
    );
    return response.data;
  }

  async getProgramModuleById(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}program-courses/${uuid}/get-modules`
    );
    return response.data;
  }

  async createModule(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}program-data/modules`,
      data
    );
    return response.data;
  }
  async updateModule(data: any, uuid: string) {
    const response = await putService.put(
      `${CONFIG_API_URL}program-data/modules/${uuid}`,
      data
    );
    return response.data;
  }

  async deleteModuleById(uuid: string) {
    const response = await deleteService.delete(
      `${CONFIG_API_URL}program-data/modules/${uuid}`
    );
    return response.data;
  }

  async createModuleCategory(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}program-data/module-categories`,
      data
    );
    return response.data;
  }

  async getModuleCategories() {
    const response = await getService.get(
      `${CONFIG_API_URL}program-data/module-categories`
    );
    return response.data;
  }

  async getModuleCategoriesByProgramId(course_uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}program-data/assessment-categories/${course_uuid}/category`
    );
    return response.data;
  }
  
  async getModuleCategoryById(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}program-data/module-categories/${uuid}`
    );
    return response.data;
  }

  async updateModuleCategory(data: any) {
    const response = await putService.put(
      `${CONFIG_API_URL}program-data/module-categories`,
      data
    );
    return response.data;
  }
  async deleteModuleCategory(uuid: string) {
    const response = await deleteService.delete(
      `${CONFIG_API_URL}program-data/module-categories/${uuid}`
    );
    return response.data;
  }
}
export default new ProgramModuleService();
